import { render, staticRenderFns } from "./deviceBinding.vue?vue&type=template&id=23db1942&scoped=true"
import script from "./deviceBinding.vue?vue&type=script&lang=js"
export * from "./deviceBinding.vue?vue&type=script&lang=js"
import style0 from "./deviceBinding.vue?vue&type=style&index=0&id=23db1942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db1942",
  null
  
)

export default component.exports